import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { FormFieldBaseComponent } from '../form-field-base.component';

@Component({
    selector: 'lib-pill-select',
    templateUrl: './form-field-pill-select.component.html',
    styleUrls: ['./form-field-pill-select.component.scss']
})
export class FormFieldPillSelectComponent<T> extends FormFieldBaseComponent<boolean, FormControl<boolean>> {
    @Input() value!: T;

    private _disabled: boolean = false;
    @Input()
    set disabled(value: boolean) {
        this._disabled = value;
        if (this._disabled) {
            this.viewControl.disable();
        } else {
            this.viewControl.enable();
        }
    }

    private _selected: boolean = false;
    @Input()
    set selected(value: boolean) {
        this._selected = value;
        this.viewControl.setValue(value);
    }

    @Input('isOptional') isOptionalOverride: boolean = false;

    constructor() {
        super();

        this.viewControl = new FormControl(this._selected, {nonNullable: true});
    }

    ChangeEvent(event: MatButtonToggleChange) {
        const value = event.source.checked ? event.value : null;
        this.formControl.setValue(value);
        this.SetFormControlValue(value);
        super.OnBlur();
    }

    override setDisabledState(state: boolean): void {
        if (state) {
            this.viewControl.disable();
        } else {
            this.viewControl.enable();
        }
    }

    get disabled(): boolean {
        return this._disabled;
    }
}
